import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const memberToken = localStorage.getItem("swk_member_token");
  const adminToken = localStorage.getItem("swk_admin_token");
  // Prefer admin token on admin paths
  if (config.url && config.url.includes("/admin/") && adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (config.url && config.url.includes("/members/")) {
    // Member-restricted route: prefer member token, fall back to admin token so admin can preview
    const token = memberToken || adminToken;
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const handleAuthExpiry = (url) => {
  if (url && url.includes("/admin/") && localStorage.getItem("swk_admin_token")) {
    localStorage.removeItem("swk_admin_token");
    localStorage.removeItem("swk_admin_email");
    if (!window.location.pathname.startsWith("/admin/login")) {
      window.location.href = "/admin/login?expired=1";
    }
    return true;
  }
  if (url && url.includes("/members/") && localStorage.getItem("swk_member_token")) {
    localStorage.removeItem("swk_member_token");
    if (!window.location.pathname.startsWith("/members/login")) {
      window.location.href = "/members/login?expired=1";
    }
    return true;
  }
  return false;
};

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      handleAuthExpiry(error.config?.url || "");
    }
    return Promise.reject(error);
  },
);

/** fetch wrapper that handles admin/member 401 → clear token + redirect. */
export const authedFetch = async (url, init) => {
  const res = await fetch(url, init);
  if (res.status === 401) {
    handleAuthExpiry(url);
  }
  return res;
};

export const formatRand = (value) => {
  if (value === null || value === undefined) return "";
  return `R${Number(value).toFixed(2)}`;
};

export const displayPrice = (product) => {
  const hasSale = product?.sale_price && product.sale_price < product.price;
  return hasSale ? product.sale_price : product?.price;
};

export const isSoldOut = (product) => {
  if (!product) return false;
  if (product.stock_status === "out_of_stock") return true;
  if (product.category === "headwear" && product.inventory !== null && product.inventory !== undefined && product.inventory <= 0) {
    return true;
  }
  return false;
};

export const resolveImageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:")) return src;
  return `${BACKEND_URL}${src}`;
};
